//=> Import React
import React, { useState, useEffect } from "react";

//=> Import Plugin
import { graphql } from "gatsby";
import { pagination } from "../../utils/pagination";
import { sortProduct } from "../../utils/sortProducts";

//=> Import Styles

//=> Import component
import Layout from "../../component/Layout";
import Header from "../../component/Header";
import NavBar from "../../component/NavBar";
import Footer from "../../component/Footer";
import ProductCard from "../../component/ProductCard";
import FilterBar from "../../component/FilterBar";
import InfoBanner from "../../component/InfoBanner";
import PaginationSelect from "../../component/PaginationSelect";
import SEO from '../../component/SEO'


//=> Import styles
import { boutiqueTitle, TextinfoNoProduct, store, contentContainer } from "./styles.module.scss";

//=> Component
const CategoriePage = ({ data }) => {


  const categorieName = data.strapiCategorie.name

  // => hook perso pour trier les produits
  const listProducts = data.strapiCategorie.products

  // J'initialise un state pour manipuler les product datas
  const [sort, setSort] = useState("")
  const [products, setProductsData] = useState(listProducts);
  const [page, setPage] = useState(1)
  const [pagininationedProducts, setPagininationedProducts] = useState([])
  const [nbrProductsToDisplay, setNbrProductsToDisplay] = useState(16)
  const [totalPage, setTotalPage] = useState(null)


  useEffect(() => {
    const sortedProduct = sortProduct(sort, listProducts)

    setProductsData(sortedProduct)

  }, [sort, page])

  useEffect(() => {
    if (!products) return
    const [paginatedProducts, totalOfPage] = pagination(nbrProductsToDisplay, products, page)
    setPagininationedProducts(paginatedProducts)
    setTotalPage(totalOfPage)
  }, [products, page, nbrProductsToDisplay, sort])


  return (
    <Layout>
      <SEO title={"Categorie"} />
      <Header />
      <NavBar />
      <div className={contentContainer}>

        <InfoBanner />
        <h2 className={boutiqueTitle} id="title">
          {` Les produits ${categorieName} de Berthes au Paquerêttes:`}
        </h2>
        <FilterBar setProducts={setSort} />

        {pagininationedProducts.length > 0 ? (
          <section className={store} >
            {pagininationedProducts.map((product) => (
              <ProductCard key={product.slug} {...product} />
            ))}

          </section>
        ) : (
          <div className={TextinfoNoProduct}>Il n'y a pas encore de produit dans cette catégorie, soyer patients 😉</div>
        )}
        {pagininationedProducts.length > 0 && (<PaginationSelect changePage={setPage} page={totalPage} productsByPage={nbrProductsToDisplay} setProductsByPage={setNbrProductsToDisplay} />)}
      </div>
      <Footer />
    </Layout>
  );
};

export const query = graphql`
  query ($id: String) {
    strapiCategorie(id: { eq: $id }) {
      name
      products {
        description
        price
        slug
        name
        image {
          file {
            url
          }
          alternativeText
        }
      }
    }
  }
`;

export default CategoriePage;
